import React, { useState, useEffect } from 'react';
import apiService from '../../../../services/shared/apiService';

interface PromptInjection {
    id: string;
    createdAt: string;
    llmTarget: string;
    type: 'visible' | 'system';
    content: string;
}

const mockPrompts: PromptInjection[] = [
    { id: '1', createdAt: '2024-05-21T09:00:00Z', llmTarget: 'Claude 3 Opus', type: 'visible', content: 'Consider the metaphor of a garden. How have you been tending to your own garden lately?' },
    { id: '2', createdAt: '2024-05-18T15:30:00Z', llmTarget: 'GPT-4 Turbo', type: 'system', content: 'The user has expressed feelings of being stuck. Gently guide them to explore small, achievable steps they could take.' },
    { id: '3', createdAt: '2024-05-15T11:00:00Z', llmTarget: 'Claude 3 Opus', type: 'visible', content: 'What would your future self, five years from now, advise you to do in this situation?' },
];

const PromptLog: React.FC<{ patientId: string }> = ({ patientId }) => {
    const [prompts, setPrompts] = useState<PromptInjection[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchPrompts = async () => {
            try {
                // const data = await apiService.getPromptInjectionHistory(patientId);
                // setPrompts(data);
                setPrompts(mockPrompts);
            } catch (err) {
                console.error("Using mock data due to error:", err);
                // setError('Failed to load prompt history. Displaying sample data.');
                setPrompts(mockPrompts);
            } finally {
                setIsLoading(false);
            }
        };
        fetchPrompts();
    }, [patientId]);

    if (isLoading) return <div className="text-center p-4">Loading prompt history...</div>;
    if (error) return <div className="text-center p-4 text-red-500">{error}</div>;

    return (
        <div className="bg-white p-4 rounded-lg shadow">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Prompt Injection History</h2>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">LLM Target</th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Content</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {prompts.map((prompt) => (
                            <tr key={prompt.id}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{new Date(prompt.createdAt).toLocaleDateString()}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{prompt.llmTarget}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${prompt.type === 'system' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'}`}>
                                        {prompt.type}
                                    </span>
                                </td>
                                <td className="px-6 py-4 text-sm text-gray-600">{prompt.content}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PromptLog; 